import React, { useEffect, useState, Fragment } from 'react';
import { XIcon } from 'lucide-react';
type TopicKey = 'contacto' | 'privacidad' | 'terminos-uso' | 'terminos-compra' | 'avisos-legales';
type LegalContent = {
  label: string;
  title: string;
  body: React.ReactNode;
};
const YEAR = new Date().getFullYear();
const CONTENT: Record<TopicKey, LegalContent> = {
  contacto: {
    label: 'Contacto',
    title: 'Contacto',
    body: <>
        <p data-id="element-111" data-mp="3kr9x43wr9m2j">
          ¿Tienes preguntas sobre el programa, tu acceso o tu compra? Nuestro
          equipo está disponible para ayudarte.
        </p>
        <p data-id="element-112" data-mp="3ugbdhv77q5h1">
          Escríbenos por WhatsApp:{' '}
          <a href="https://wa.link/infocommerce" target="_blank" rel="noopener noreferrer" className="text-[#0e7490] underline font-semibold" data-id="element-113" data-mp="3uh35kw1lpl2k">
            wa.link/infocommerce
          </a>
        </p>
        <p data-id="element-114" data-mp="31yfsa2sujac1">
          Correo de soporte:{' '}
          <a href="mailto:soporte@truemarketer.com" className="text-[#0e7490] underline font-semibold" data-id="element-115" data-mp="2x0xjqdiqqx4k">
            soporte@truemarketer.com
          </a>
        </p>
        <p className="text-[#64748b]" data-id="element-116" data-mp="1dujgrig2upuk">
          Respondemos normalmente en un plazo de 24 a 48 horas hábiles.
        </p>
      </>
  },
  privacidad: {
    label: 'Política de Privacidad',
    title: 'Política de Privacidad',
    body: <>
        <p data-id="element-117" data-mp="1rlwx6niov7ld">
          En True Marketer LLC respetamos tu privacidad y nos comprometemos a
          proteger los datos personales que compartes con nosotros.
        </p>
        <p data-id="element-118" data-mp="uy0ar20kli28">
          <b data-id="element-119" data-mp="yxiz67rlob9t">Información que recopilamos.</b> Recopilamos los datos que nos
          proporcionas al registrarte o comprar (nombre, correo electrónico y
          datos de pago procesados de forma segura por nuestros proveedores),
          así como información técnica básica de uso del sitio.
        </p>
        <p data-id="element-120" data-mp="2fbr6iv3sue0v">
          <b data-id="element-121" data-mp="2fcafhmbh1s2r">Cómo usamos tu información.</b> Utilizamos tus datos para procesar
          tu compra, darte acceso al programa, brindarte soporte y enviarte
          comunicaciones relacionadas con el producto. No vendemos tu
          información personal a terceros.
        </p>
        <p data-id="element-122" data-mp="1pnn8s6lj2nnx">
          <b data-id="element-123" data-mp="1pnvijpmctcuw">Tus derechos.</b> Puedes solicitar acceso, corrección o eliminación
          de tus datos en cualquier momento escribiendo a nuestro equipo de
          soporte.
        </p>
        <p className="text-[#64748b]" data-id="element-124" data-mp="1zlt6sd47r9ni">
          Última actualización: {YEAR}. © {YEAR} True Marketer LLC.
        </p>
      </>
  },
  'terminos-uso': {
    label: 'Términos de Uso',
    title: 'Términos de Uso',
    body: <>
        <p data-id="element-125" data-mp="16xx2oncbefgp">
          Al acceder y utilizar este sitio aceptas los presentes Términos de
          Uso. Si no estás de acuerdo, te pedimos que no utilices el sitio.
        </p>
        <p data-id="element-126" data-mp="1gvl9wcr3xffr">
          <b data-id="element-127" data-mp="1gurxow9dpxq8">Uso del contenido.</b> Todo el material disponible en este sitio y
          en el programa es propiedad de True Marketer LLC y está protegido por
          las leyes de propiedad intelectual. No está permitido reproducir,
          distribuir ni revender el contenido sin autorización por escrito.
        </p>
        <p data-id="element-128" data-mp="2zsya53awmm5n">
          <b data-id="element-129" data-mp="2zsetdpwzq3t7">Naturaleza educativa.</b> El contenido es de carácter educativo. No
          constituye asesoría legal, financiera ni de inversión. Eres
          responsable de tus propias decisiones y resultados.
        </p>
        <p data-id="element-130" data-mp="2ptqoztxxhn7z">
          <b data-id="element-131" data-mp="2ptz3fq9p90la">Disponibilidad.</b> Nos reservamos el derecho de modificar,
          suspender o discontinuar cualquier parte del sitio o del programa en
          cualquier momento.
        </p>
        <p className="text-[#64748b]" data-id="element-132" data-mp="3iio4xqeo37xk">
          Última actualización: {YEAR}. © {YEAR} True Marketer LLC.
        </p>
      </>
  },
  'terminos-compra': {
    label: 'Términos de Compra',
    title: 'Términos de Compra',
    body: <>
        <p data-id="element-133" data-mp="3dkuxku1mo7vp">
          Estos Términos de Compra aplican a toda adquisición realizada a través
          de este sitio.
        </p>
        <p data-id="element-134" data-mp="1y3ugpkygw1gw">
          <b data-id="element-135" data-mp="1y3cdu5haup00">Pago.</b> Los pagos se procesan de forma segura a través de
          nuestros proveedores. Al completar tu compra autorizas el cargo
          correspondiente al método de pago seleccionado.
        </p>
        <p data-id="element-136" data-mp="2ifghwlzvvp1y">
          <b data-id="element-137" data-mp="2dmnga6zpowu3">Acceso.</b> Una vez confirmado el pago, recibirás acceso al
          programa y a los bonos incluidos según la oferta vigente al momento de
          la compra.
        </p>
        <p data-id="element-138" data-mp="28lhivvv3wle8">
          <b data-id="element-139" data-mp="23ohh3x5ai4sx">Garantía de devolución.</b> Ofrecemos una garantía de devolución
          conforme a las condiciones indicadas en la página de oferta. Para
          solicitar un reembolso, contacta a nuestro equipo de soporte dentro
          del plazo establecido.
        </p>
        <p className="text-[#64748b]" data-id="element-140" data-mp="2wdy7kp9cnbmi">
          Última actualización: {YEAR}. © {YEAR} True Marketer LLC.
        </p>
      </>
  },
  'avisos-legales': {
    label: 'Avisos Legales',
    title: 'Avisos Legales',
    body: <>
        <p data-id="element-141" data-mp="1fyww78pksxh0">
          En True Marketer LLC creemos que el éxito es resultado del trabajo, la
          educación y la persistencia.
        </p>
        <p data-id="element-142" data-mp="1bwidqpptjzq9">
          Los ejemplos y resultados mostrados no deben considerarse típicos y no
          representan una garantía de resultados. Tus resultados dependerán de
          tu esfuerzo, experiencia y ejecución.
        </p>
        <p data-id="element-143" data-mp="3rk5t53yxzw3o">
          La información de este sitio es de naturaleza educativa y no
          constituye asesoría legal ni financiera. Al usar este sitio aceptas la
          responsabilidad total de tus propios resultados.
        </p>
        <p data-id="element-144" data-mp="a6a3fmaq4lo9">
          Este sitio no está afiliado, patrocinado ni respaldado por Meta,
          Facebook ni por ninguna otra plataforma de terceros.
        </p>
        <p className="text-[#64748b]" data-id="element-145" data-mp="f6y30wd0qau3">
          <b className="text-[#0f172a]" data-id="element-146" data-mp="j5x7ygyr27lj">True Marketer LLC</b> — © {YEAR} True
          Marketer LLC. Todos los derechos reservados.
        </p>
      </>
  }
};
const ORDER: TopicKey[] = ['privacidad', 'terminos-uso', 'terminos-compra', 'avisos-legales'];
type LegalLinksProps = {
  containerClassName?: string;
  linkClassName?: string;
};
export function LegalLinks({
  containerClassName = '',
  linkClassName = ''
}: LegalLinksProps) {
  const [active, setActive] = useState<TopicKey | null>(null);
  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActive(null);
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [active]);
  const current = active ? CONTENT[active] : null;
  return <>
      <div className={containerClassName} data-id="element-147" data-mp="otcb97iq7bec">
        {ORDER.map((key, i) => <Fragment key={key} data-id="element-148" data-mp="ossv9wcmyx2y" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" data-id="element-149" data-mp="krgzf9365fmb">|</span>}
            <button type="button" onClick={() => setActive(key)} className={linkClassName} data-id="element-150" data-mp="ksik859zlgh8">
              {CONTENT[key].label}
            </button>
          </Fragment>)}
      </div>

      {current && <div role="dialog" aria-modal="true" aria-label={current.title} className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-151" data-mp="tu8ediv96tip">
          <div className="absolute inset-0 bg-black/60" onClick={() => setActive(null)} data-id="element-152" data-mp="1ida2432a6scg" />
          <div className="relative w-full max-w-[640px] max-h-[85vh] flex flex-col bg-white rounded-2xl shadow-2xl overflow-hidden text-left" data-id="element-153" data-mp="13gaz6sidjnob">
            <div className="flex items-center justify-between gap-4 px-6 py-4 border-b border-[#e2e8f0]" data-id="element-154" data-mp="18e2r3mj0r9si">
              <h2 className="text-[18px] sm:text-[20px] font-extrabold text-[#0f172a]" data-id="element-155" data-mp="un7hg80p4onv">
                {current.title}
              </h2>
              <button type="button" onClick={() => setActive(null)} aria-label="Cerrar" className="shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-full text-[#64748b] hover:bg-[#f1f5f9] hover:text-[#0f172a] transition-colors" data-id="element-156" data-mp="zgil60a7opbk">
                <XIcon className="w-5 h-5" data-id="element-157" data-mp="bq68yd7xo6f6" />
              </button>
            </div>
            <div className="px-6 py-5 overflow-y-auto text-[14px] leading-relaxed text-[#334155] space-y-3.5" data-id="element-158" data-mp="fr8bp41270lw">
              {current.body}
            </div>
          </div>
        </div>}
    </>;
}